import React from "react"

import * as S from "./styled"

const Button = props => (
  <S.Button
    background={props.background}
    color={props.color}
    flat={props.flat}
    padding={props.padding}
  >
    {props.children}
  </S.Button>
)

export default Button
